import React, {PureComponent} from 'react';

import Wrapper from './Wrapper';

class LessonAbortModalHandler extends PureComponent {

    constructor(props) {
        super(props);

        this.handleAbortWish = this.toggle.bind(this, true);
        this.handleCancelAbortWish = this.toggle.bind(this, false);

        this.state = {
            show: false,
        };
    }

    render() {
        return (
            <Wrapper
                {...this.state}
                {...this.props}
                onClick={this.handleAbortWish}
                onCancel={this.handleCancelAbortWish}
            />
        );
    }

    toggle(show, event) {
        if (event && event.preventDefault) event.preventDefault();
        this.setState({show});
    }

}

export default LessonAbortModalHandler;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/LessonAbortModal/index.js